import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { Row, Col, Container, CardBody, Button, Card } from 'reactstrap';
import * as commonActions from '@common/common.action';
import * as actions from './store/relatorios.action';
import ComponentesArquivamento from '../../common/components';
import ArquivamentoApi from '../../arquivamento.api';
import Auditoria from '../../common/components/Auditoria';
import Arquivamento from '../../common/components/Arquivamento';
import Requisicao from '../../common/components/Requisicao';
import SelectComponent from '@componentes/select/select.component';
import * as Utils from '../../arquivamento.utils';
import { acessoPermitido } from '../../../../acessos.seguranca';
import * as acessos from '../../../../acessos.const.util';
import IntlMessage from '../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import CommonFunctions from '@common/util/functions.common';

const optionsArquivamento = Utils.optionsFiltroArquivamento;
const optionsTipoMaterial = Utils.arquivamentoManualTipoOptions;

function Relatorios({ showMessageByResults }) {
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  const componentRef = useRef();
  const dispatch = useDispatch();
  const usuario = useSelector(state => state.usuario);
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );
  const arquivamentoRelatorios = useSelector(
    state => state.arquivamentoRelatorios
  );

  const [tipoRelatorio, setTipoRelatorio] = useState('');
  const [selectFilter, setSelectFilter] = useState('');
  const [search, setSearch] = useState(false);
  const [listaTemporaria, setListaTemporaria] = useState([]);
  const [listaPesquisa, setListaPesquisa] = useState([]);
  const [optionsTipoArquivamento, setOptionsTipoArquivamento] = useState(
    Utils.tipoArquivamentoOptions(intl)
  );

  useEffect(() => {
    dispatch(actions.lista([]));
  }, []);

  useEffect(() => {
    const list = [];
    switch (tipoRelatorio) {
      case 1:
        list.push(optionsArquivamento.find(x => x.value === 'dtpedido'));
        break;
      case 2:
        list.push(optionsArquivamento.find(x => x.value === 'dtarquivamento'));
        break;
      case 3:
        list.push(optionsArquivamento.find(x => x.value === 'dtdevolucao'));
        break;

      default:
        break;
    }
    list.push(optionsArquivamento.find(x => x.value === 'nrExame'));
    setListaPesquisa(list);
  }, [tipoRelatorio]);

  useEffect(() => {
    setListaTemporaria(arquivamentoRelatorios.lista);
  }, [arquivamentoRelatorios.lista]);

  useEffect(() => {
    const acessoArquivamento = acessoPermitido(
      usuario,
      acessos.ConsultaArquivamentoBlocosELaminas
    );
    const acessoRequisicao = acessoPermitido(
      usuario,
      acessos.ConsultaRequisicaoBlocosELaminas
    );
    let lista = Utils.tipoArquivamentoOptions(intl);
    if (!acessoArquivamento) {
      lista = lista.filter(
        x => x.value !== Utils.tipoArquivamentoEmum.ARQUIVAMENTO
      );
    }
    if (!acessoRequisicao) {
      lista = lista.filter(
        x => x.value !== Utils.tipoArquivamentoEmum.REQUISICAO
      );
    }
    setOptionsTipoArquivamento(lista);
  }, [usuario]);

  function changeFilter(e) {
    setSelectFilter(e);
  }

  function changeTipoRelatorio(e) {
    const tipo = Number(e.value) === 3 ? 2 : Number(e.value);
    const listaByTipo = listaTemporaria.filter(
      x => x.tipoArquivamento === tipo
    );
    dispatch(actions.lista(listaByTipo));
    setTipoRelatorio(e.value);
    setSelectFilter('');
  }

  function montarData(data) {
    let newData = [];
    data.map(d =>
      // eslint-disable-next-line array-callback-return
      optionsTipoMaterial.find(x => {
        if (x.value === d.tipo) {
          d.tipo = x.label;
        }
        newData.push(d);
      })
    );
    setListaTemporaria(newData);
  }

  function downloadCSVFromJson(filename, arrayOfJson) {
    // convert JSON to CSV
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(arrayOfJson[0]);
    let csv = arrayOfJson.map(row =>
      header
        .map(fieldName => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    csv = csv.join('\r\n');

    // Create link and download
    var link = document.createElement('a');
    link.setAttribute(
      'href',
      'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv)
    );
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function handleLoadData() {
    const { filtroValue, dataInicio, dataFim } = arquivamentoRelatorios;
    let executarValidacaoDeData = (selectFilter.value.indexOf('dt') >= 0);
    let result = {valid: true, message: ''};

    if (executarValidacaoDeData)
      result = CommonFunctions.validaData(dataInicio, dataFim, intl);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    setSearch(true);
    dispatch(commonActions.showFadeCarregando(true));
    const tipo = Number(tipoRelatorio);

    ArquivamentoApi.getItensRelatorio(
      tipo,
      selectFilter ? selectFilter.value : '',
      filtroValue,
      dataInicio,
      dataFim
    ).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));
      dispatch(actions.lista(resp));
      montarData(resp);
      showMessageByResults(resp.length);
    });
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  return (
    <React.Fragment>
      <div className='mv-descarte-tab relatorios'>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={2}>
                    <SelectComponent
                      options={optionsTipoArquivamento}
                      placeholder={translate("general.materialArchiving.reportType")}
                      defaultValue={tipoRelatorio}
                      onChange={e => changeTipoRelatorio(e)}
                    />
                  </Col>
                  <Col xs={3} style={{ maxWidth: 300 }}>
                    <SelectComponent
                      options={listaPesquisa}
                      placeholder={translate("general.materialArchiving.chooseOne")}
                      value={selectFilter}
                      onChange={e => changeFilter(e)}
                      disabled={!tipoRelatorio}
                    />
                  </Col>
                  {selectFilter.value && (
                    <div className='col-auto'>
                      <ComponentesArquivamento
                        component={selectFilter.value}
                        onPressEnter={handleLoadData}
                      />
                    </div>
                  )}
                  <Col xs={1}>
                    <Button
                      style={{ height: '38px', width: '38px'}}
                      className='btn btn-primary'
                      disabled={!selectFilter.value || tipoRelatorio === ''}
                      onClick={handleLoadData}
                    >
                      <i className='icons-btn mv-basico-pesquisar'></i>
                    </Button>
                  </Col>

                  <div className='btn-group_right'>
                    {!!arquivamentoRelatorios.lista.length &&
                      (tipoRelatorio === Utils.tipoArquivamentoEmum.AUDITORIA ||
                        tipoRelatorio ===
                        Utils.tipoArquivamentoEmum.ARQUIVAMENTO ||
                        tipoRelatorio ===
                        Utils.tipoArquivamentoEmum.REQUISICAO) && (
                        <div className='col-auto'>
                          {/* <Button
                            className='btn btn-csv btn-primary'
                            onClick={() =>
                              downloadCSVFromJson(
                                `${optionsTipoArquivamento.find(
                                  x => x.value === tipoRelatorio && x
                                ).label
                                }.csv`,
                                listaTemporaria
                              )
                            }
                          >
                            <i className='icons-btn mv-basico-exportar_csv'></i>{' '}
                            <IntlMessage id="general.materialArchiving.exportCSV" />
                          </Button> */}
                        </div>
                      )}
                    {!!arquivamentoRelatorios.lista.length &&
                      (tipoRelatorio === Utils.tipoArquivamentoEmum.AUDITORIA ||
                        tipoRelatorio ===
                        Utils.tipoArquivamentoEmum.ARQUIVAMENTO ||
                        tipoRelatorio ===
                        Utils.tipoArquivamentoEmum.REQUISICAO) && (
                        <div className='col-auto'>
                          <Button
                            className='btn btn-imprimir btn-success'
                            onClick={handlePrint}
                          >
                            <i className='icons-btn mv-basico-imprimir'></i>{' '}
                            <IntlMessage id="general.materialArchiving.printOut" />
                          </Button>
                        </div>
                      )}
                  </div>
                </Row>
              </CardBody>
            </Card>

            {!!arquivamentoRelatorios.lista.length && (
              <Card>
                <CardBody
                  style={{
                    height: '82vh',
                    overflow: 'scroll',
                    overflowX: 'hidden'
                  }}
                >
                  <Container fluid>
                    <div ref={componentRef}>
                      <div>
                        {tipoRelatorio ===
                          Utils.tipoArquivamentoEmum.AUDITORIA && (
                            <Auditoria lista={arquivamentoRelatorios.lista} />
                          )}
                        {tipoRelatorio ===
                          Utils.tipoArquivamentoEmum.ARQUIVAMENTO && (
                            <Arquivamento lista={arquivamentoRelatorios.lista} />
                          )}

                        {tipoRelatorio ===
                          Utils.tipoArquivamentoEmum.REQUISICAO && (
                            <Requisicao lista={arquivamentoRelatorios.lista} />
                          )}
                      </div>
                    </div>
                  </Container>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
        {!search && (
          <div className='icone-semdados'>
            <i className='inicial-icons mv-basico-documento_eletronico'></i>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default Relatorios;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Relatorios/index.js